export const EMPTY_CART= 'EMPTY_CART'
export const EMPTY_CART_SUCCESS= 'EMPTY_CART_SUCCESS'
export const EMPTY_CART_ERROR='EMPTY_CART_ERROR'

export const EmptyCart= (data) => ({
    type: EMPTY_CART,
    payload: data
})